module.exports = __webpack_public_path__ + "static/img/flying-doctors-korea.5e54ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/flying-doctors-korea.jpg
// module id = bD5m
// module chunks = 0